

const SocialMediaArea=()=>{
    return(
        <div className="flex justify-center md:justify-start my-10 gap-7">
          <a className="hover:opacity-50 transition duration-500" 
          href="https://www.linkedin.com/in/yash-agarwal-32797b1a1/"
          target="_blank"
          rel="noreferrer">
            <img alt="linked-link" src="../assets/linkedin.png"/></a>
            <a className="hover:opacity-50 transition duration-500" 
          href="https://www.linkedin.com/in/yash-agarwal-32797b1a1/"
          target="_blank"
          rel="noreferrer">
            <img alt="linked-link" src="../assets/instagram.png"/></a>

           <a className="hover:opacity-50 transition duration-500" 
          href="https://www.linkedin.com/in/yash-agarwal-32797b1a1/"
          target="_blank"
          rel="noreferrer">
            <img alt="linked-link" src="../assets/twitter.png"/></a>
            <a className="hover:opacity-50 transition duration-500" 
          href="https://www.linkedin.com/in/yash-agarwal-32797b1a1/"
          target="_blank"
          rel="noreferrer">
            <img alt="linked-link" src="../assets/facebook.png"/></a>

        </div>
    ) 
}
export default SocialMediaArea